//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
export default {
  props: {
    // 父辈向子辈传参
    data: {
      type: Object,
      default: () => {},
    },
    productId: {
      type: Number,
      default: () => 0,
    },
  },
  name: "CustomerReviews",
  data() {
    return {
      params: {
        page: 1,
        limit: 8,
      },
      isNext: true, //判断是否进行下一步滚动加载动作
      reviewsItems: JSON.parse(JSON.stringify(this.data)),
      reviewsItemsArr: [], //评论列表数组
      selectIndex: 0,
      previewGalleryItems: [],
      nowPreviewGalleryItems: [],
      reviewsCategory: [
        {
          type: "all",
          title: "All",
        },
        {
          type: "has_image",
          title: "Photo Comments",
        },
        {
          type: "sort",
          title: "likes",
        },
      ],
      pageNo: 1, //当前页码
      // pageSize:4,//一页展示几条数据
      pagerCount: 5, //连续页码数
    };
  },
  created() {
    // 实例被创建之后执行代码
  },
  computed: {
    // 计算属性
    ...mapGetters("user", ["isLogin"]),
    totalNum() {
      if (this.selectIndex == 0) {
        return this.data.paginate?.total;
      } else {
        return this.reviewsItemsArr.length;
      }
    },
  },
  components: {
    // 组件的引用
  },
  methods: {
    // 方法
    /**
     * @Author: liguohua 2490322461@qq.com
     * @Date: 2023-03-13 13:52:22
     * @LastAuthor: liguohua 2490322461@qq.com
     * @description: 评论类型切换显示
     * @param {*} item
     * @param {*} index
     * @return {*}
     * @Description: Do not Description
     */
    async reviewsCategoryFilter(item, index) {
      if (this.selectIndex == index) {
        return;
      }
      try {
        this.params = {
          page: 1,
          limit: 8,
        };
        this.selectIndex = index;
        this.params.product_id = this.productId;
        if (item.type == "has_image") {
          this.params.has_image = 1;
        } else if (item.type == "sort") {
          this.params.sort = "like_num";
        } else if (item.type == "keyword") {
          this.params.keyword = item.title;
        }
        let res = await this.$reviewList(this.params);
        if (res.code == 200000) {
          this.reviewsItems = res.data;
          this.reviewsItemsArr = this.reviewsItems.list;
          if (this.params.page * this.params.limit >= this.reviewsItems.paginate.total) {
            this.isNext = false;
          } else {
            this.isNext = true;
          }
        }
      } catch (error) {
        throw new Error("评论类型切换显示" + error);
      }
    },

    // 评论分页。
    async reviewsItemsMoreHandler(page) {
      this.isNext = false;
      this.params.product_id = this.productId;
      this.params.page = page;
      let res = await this.$reviewList(this.params);
      if (res.code == 200000) {
        this.reviewsItems = res.data;
        this.reviewsItemsArr = this.reviewsItems.list;
        if (this.params.page * this.params.limit >= this.reviewsItems.paginate.total) {
          this.isNext = false;
        } else {
          this.isNext = true;
        }
      }
    },
    /**
     * @Author: liudanli 565478958@qq.com
     * @Date: 2023-05-30 15:28:14
     * @LastAuthor: liudanli 565478958@qq.com
     * @description:评论里的点赞
     * @param {*} item
     * @param {*} type
     * @return {*}
     * @Description: Do not Description
     */
    async changeLikeHandler(item, type) {
      try {
        let res = await this.$reviewItemLike(item.id);
        if (res.code == 200101) {
          this.$toast({ type: "fail", content: res.message });
        } else {
          // this.$set(item, "isLike", 1);
          if (type == "like") {
            item.isLike = 1;
            item.likeNum += 1;
          } else {
            item.isLike = 0;
            item.likeNum -= 1;
          }
        }
      } catch (error) {
        throw new Error("详情页点赞" + error);
      }
    },
    currentPageHandler(page) {
      this.pageNo = page;
      this.reviewsItemsMoreHandler(page);
    },
    /**
     * @Author: liudanli
     * @Date: 2023-06-26 08:33:32
     * @LastEditTime: Do not edit
     * @description: 点击预览评论图片
     * @param {*} index
     * @param {*} type
     * @return {*}
     */
    showPreviewDialog(index, id) {
      try {
        this.nowPreviewGalleryItems = this.previewGalleryItems;
        let newIndex = this.previewGalleryItems.findIndex((item) => item.id == id && index == item.imgindex);
        console.log(newIndex, "newIndex");
        this.$refs.previewGalleryImgDialog?.mySwiper.slideTo(newIndex);
        this.$refs.previewGalleryImgDialog.changeDialog();
      } catch (error) {
        throw new Error("预览弹窗" + error);
      }
    },
    // 获取评论图片
    async reviewsImgList() {
      this.params = {
        page: 1,
        limit: 15,
        has_image: 1,
        product_id: this.productId,
      };
      let res = await this.$reviewList(this.params);
      res.data.list.map((item) => {
        if (item.image.length > 0) {
          item.image.forEach((item2, index) => {
            this.previewGalleryItems.push({ ...item, imgUrl: item2, imgindex: index });
          });
        }
      });
      console.log(this.previewGalleryItems, "所有图片");
    },
  },
  mounted() {
    // 页面进入时加载内容
    this.reviewsItemsArr = this.reviewsItems.list; //保存列表内容
    let keyWords = this.reviewsItems.reviewKeywords;
    // keyWords = keyWords.map((item) => ({
    //   type: "keyword",
    //   title: item.keyword,
    // }));
    this.reviewsCategory = this.reviewsCategory.concat(keyWords);
    this.reviewsImgList();
  },
  watch: {
    // 监测变化
  },
};
